import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useI18n } from '../i18n';

type RouteLoadBoundaryState = { failed: boolean };

class RouteLoadBoundary extends React.Component<React.PropsWithChildren, RouteLoadBoundaryState> {
  state: RouteLoadBoundaryState = { failed: false };

  static getDerivedStateFromError(): RouteLoadBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Route chunk failed to load', error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <RouteLoadError />;
  }
}

function RouteLoadError() {
  const { t } = useI18n();
  return (
    <section className="ui-screen flex min-h-[40vh] items-center justify-center">
      <div className="w-full max-w-lg border-y border-gray-200 bg-white px-4 py-8 text-center sm:px-6">
        <AlertTriangle size={28} className="mx-auto text-orange-600" aria-hidden="true" />
        <h1 className="mt-3 text-xl font-bold text-gray-950">{t('route_load_error_title')}</h1>
        <p className="mt-2 text-sm leading-6 text-gray-600">{t('route_load_error_description')}</p>
        <button type="button" onClick={() => window.location.reload()} className="mt-5 inline-flex min-h-11 w-full items-center justify-center gap-2 bg-gray-950 px-4 text-sm font-bold text-white sm:w-auto"><RefreshCw size={17} aria-hidden="true" /> {t('route_load_error_retry')}</button>
      </div>
    </section>
  );
}

export default RouteLoadBoundary;
